import Dropdown from "../Dropdown";
import { projectMenus } from "../ProjectMenus";

export default function MeetingMenu(props) {
  return (
    <Dropdown
      menuKey="meeting"
      menu={projectMenus.meeting}
      {...props}
    />
  );
}
